/* global canvas_data, previews */
import Pickr from "@simonwep/pickr";
import "@simonwep/pickr/dist/themes/nano.min.css";
import {FILE_TYPE} from "./constants/file-image-types";
import fileDocSvg from "./templates/file_image/file-doc-svg";
import filePdfSvg from "./templates/file_image/file-pdf-svg";
import filePsdSvg from "./templates/file_image/file-psd-svg";
import fileXlsSvg from "./templates/file_image/file-xls-svg";
import fileZipSvg from "./templates/file_image/file-zip-svg";
import fileTiffSvg from "./templates/file_image/file-tiff";
import fileSvg from "./templates/file_image/file-svg";
import fileMp4Svg from "./templates/file_image/file-mp4-svg";
import fileMp3Svg from "./templates/file_image/file-mp3-svg";
import fileAviSvg from "./templates/file_image/file-avi-svg";
import fileMovSvg from "./templates/file_image/file-mov-svg";
import filePptSvg from "./templates/file_image/file-ppt-svg";
import filePptxSvg from "./templates/file_image/file-pptx-svg";
import fileLoadingSvg from "./templates/file_image/file-loading-svg";
import fileAnySvg from "./templates/file_image/file-any-svg";
import fileGifSvg from "./templates/file_image/file-gif-svg";
import fileWebmSvg from "./templates/file_image/file-webm-svg";
import fileLink from "./templates/file_image/file-link";
import folderSvg from "./templates/file_image/folder-svg";
import folderUpSvg from "./templates/file_image/folder-up-svg";
import fileAiSvg from './templates/file_image/file-ai-svg'
import fileEpsSvg from './templates/file_image/file-eps-svg'
import fileLayoutSvg from "@frontend/templates/file_image/file-layout";
import fileVttSvg from '@frontend/templates/file_image/file-vtt-svg'
import fileTtfSvg from '@frontend/templates/file_image/file-ttf-svg'
import fileOtfSvg from '@frontend/templates/file_image/file-otf-svg'
import { PRIMARY_MODE, SECONDARY_MODE } from '@frontend/group/modules/dominant-colors';
import {
  FIELD_TYPE_MULTI_LINE_TEXT,
  FIELD_TYPE_TEXT,
  FIELD_TYPE_TEXT_FROM_SPREADSHEET,
  FIELD_TYPE_TEXT_OPTIONS
} from '@frontend/constants/type-fields-of-template';
import { TEXT_PREFIX_ID } from '@frontend/constants/templates-field-prefixes';
import { fabric } from 'fabric';
import { SettingsTemplateData } from '@frontend/group/modules/classes-for-preview-data/settings-template-data';
import { parseJsonData } from '@frontend/services/helpers';
import { ShowPageScopeCollector } from '@frontend/group/modules/scope-collectors/show-page-collector';
import fileCsvSvg from "@frontend/templates/file_image/file-csv-svg";
import fileTifSvg from "@frontend/templates/file_image/file-tif";
import {createGradient} from "@frontend/utils/gradient-helper";

const getShowPageScope = () => ShowPageScopeCollector.get([
  'previews',
  'getIsLightweight',
]);

const eyeDroppers = []

export function delay(time) {
  return new Promise((resolve) => setTimeout(resolve, time));
}

export const deepCopy = (a) => {
  if (!a) return a;
  return JSON.parse(JSON.stringify(a));
};

export const isValidJson = (str) => {
  try {
    JSON.parse(str);
    return true;
  } catch (e) {
    return false;
  }
}

export function isValidHexColor (color) {
  return /^#[0-9a-fA-F]{6}$/.test(color)
}

export function drawFileSvg(element) {
  switch (element.type) {
    case FILE_TYPE.FOLDER:
      if (element.name !== undefined && element.name == '...'){
        return folderUpSvg();
      }else{
        return folderSvg({
          color: element.color || null,
          emoji: element.emoji || null,
        });
      }
    case FILE_TYPE.DOC:
      return fileDocSvg();
    case FILE_TYPE.PDF:
      if (!element.thumbnail_path) {
        return filePdfSvg();
      }
      if (element.is_processing) {
        return fileLoadingSvg();
      }
      return drawFileImageThumbnail(element);
    case FILE_TYPE.XLS:
      return fileXlsSvg();
    case FILE_TYPE.ZIP:
      return fileZipSvg();
    case FILE_TYPE.PSD:
      if (!element.thumbnail_path) {
        return filePsdSvg();
      }
      if (element.is_processing) {
        return fileLoadingSvg();
      }
      return drawFileImageThumbnail(element);
    case FILE_TYPE.IDML:
      if (!element.thumbnail_path) {
        return fileAnySvg();
      }
      if (element.is_processing) {
        return fileLoadingSvg();
      }
      return drawFileImageThumbnail(element);
    case FILE_TYPE.SVG:
      if (!element.thumbnail_path) {
        return fileSvg();
      }
      if (element.is_processing) {
        return fileLoadingSvg();
      }
      return drawFileImageThumbnail(element);
    case FILE_TYPE.TIFF:
    case FILE_TYPE.TIF:
      if (element.thumbnail && element.thumbnail.endsWith('.tif')) {
        return fileTifSvg()
      }
      if (element.thumbnail && element.thumbnail.endsWith('.jpg')) {
        return drawProductTiffThumbnail(element);
      }
      if (!element.thumbnail_path) {
        return fileTiffSvg();
      }
      if (element.is_processing) {
        return fileLoadingSvg();
      }
      return drawFileImageThumbnail(element);
    case FILE_TYPE.MP4:
      if (element.is_processing) {
        return fileLoadingSvg();
      }
      return drawFileVideoPreview(element);
    case FILE_TYPE.MP3:
      return fileMp3Svg()
    case FILE_TYPE.AVI:
      return fileAviSvg()
    case FILE_TYPE.MOV:
      if (!element.thumbnail_path) {
        return fileMovSvg();
      }
      if (element.is_processing) {
        return fileLoadingSvg();
      }
      return drawFileImageThumbnail(element);
    case FILE_TYPE.PPT:
      return filePptSvg();
    case FILE_TYPE.PPTX:
      return filePptxSvg();
    case FILE_TYPE.GIF:
      return drawFileGifPreview(element);
    case FILE_TYPE.WEBM:
      return fileWebmSvg()
    case FILE_TYPE.PSB:
      return `<img alt='image' src='/img/icons/psb.png' loading='lazy' style='max-width: 170px' />`;
    case FILE_TYPE.IMAGE:
    case FILE_TYPE.JPG:
    case FILE_TYPE.JPEG:
      if (element.image_type === FILE_TYPE.GIF) {
        return drawFileGifPreview(element);
      }
      if (element.is_processing) {
        return fileLoadingSvg();
      }
      return drawFileImageThumbnail(element);
    case FILE_TYPE.BOX_FILE:
      if (!element.thumbnail_path) {
        return fileAnySvg();
      }
      if (element.is_processing) {
        return fileLoadingSvg();
      }
      return drawFileImageThumbnail(element);
    case FILE_TYPE.LINK:
      return fileLink();
    case FILE_TYPE.AI:
      return fileAiSvg()
    case FILE_TYPE.EPS:
      if (element.thumbnail_path) {
        return drawFileImageThumbnail(element)
      }
      return fileEpsSvg()
    case FILE_TYPE.LAYOUT:
      return fileLayoutSvg()
    case FILE_TYPE.CSV:
      return fileCsvSvg();
    case FILE_TYPE.VTT:
      return fileVttSvg();
    case FILE_TYPE.TTF:
      return fileTtfSvg();
    case FILE_TYPE.OTF:
      return fileOtfSvg();
    case FILE_TYPE.WEBP:
      return drawFileImageThumbnail(element);
    case FILE_TYPE.AVIF:
      if (element.thumbnail) {
        return drawFileImageThumbnail(element);
      }

      if (!element.thumbnail_path) {
        return fileAnySvg();
      }
      if (element.is_processing) {
        return fileLoadingSvg();
      }
      return drawFileImageThumbnail(element);
    case FILE_TYPE.PNG:
      if (element?.asset_type === 'salsify' || element?.asset_type === 'bynder' || element?.asset_type === 'rapid_stock' || element?.asset_type === 'pixabay') {
        return drawFileImageThumbnail(element);
      } else {
        break;
      }
    default:
      return fileAnySvg();
  }
}

export const isExternalAsset = (el) => {
  return !!(el?.asset_type === 'salsify' || el?.asset_type === 'bynder') || el?.asset_type === 'rapid_stock' || el?.asset_type === 'pixabay' || el?.asset_type === 'box';
}

function drawFileVideoPreview(element) {
  let return_draw = '';

  const imageUrl = element.thumbnail_path || element.path;

  const isExternal = isExternalAsset(element);

  if (imageUrl) {
    if (isExternal) {
      return_draw = `<img alt="image" src="${imageUrl}" loading="lazy"/>`;
    } else {
      return_draw = `<img alt="image" src="${imageUrl + '&is_thumbnail=1'}" loading="lazy"/>`;
    }
  } else {
    return_draw = fileMp4Svg();
  }

  return_draw += `<div class="video-container" data-video-src="${element.path}"></div>`;

  return return_draw;
}

const drawProductTiffThumbnail = (el) => {
  return `<img alt="image" src="/share?file=${el.thumbnail}" loading="lazy"/>`;
}

function drawFileImageThumbnail(element) {
  const imageUrl = element.thumbnail_path || element.url || element.path;

  const isExternal = isExternalAsset(element);

  if (isExternal) {
    return "<img alt='image' src='" + imageUrl + "' loading='lazy'/>";
  }

  return "<img alt='image' src='" + imageUrl + "&is_thumbnail=1' loading='lazy'/>";
}

function drawFileGifPreview(element) {
  if (element.is_processing) {
    return fileLoadingSvg();
  }

  const isExternal = isExternalAsset(element);
  const animatedSrc = element.url || element.path;
  const hasStaticThumbnail = !!element.thumbnail_path;

  if (!hasStaticThumbnail && !animatedSrc) {
    return fileGifSvg();
  }

  // Prefer a static JPG thumbnail; fall back to the GIF itself when none exists.
  let staticSrc;
  if (hasStaticThumbnail) {
    staticSrc = isExternal
      ? element.thumbnail_path
      : element.thumbnail_path + '&is_thumbnail=1';
  } else {
    staticSrc = animatedSrc;
  }

  const canAnimateOnHover = hasStaticThumbnail && animatedSrc;

  if (canAnimateOnHover) {
    return `<img alt='image' class='gif-thumbnail' src='${staticSrc}' data-static-src='${staticSrc}' data-animated-src='${animatedSrc}' loading='lazy'/>`;
  }

  return `<img alt='image' src='${staticSrc}' loading='lazy'/>`;
}

export function playGifThumbnail(container) {
  const img = container?.querySelector?.('img.gif-thumbnail[data-animated-src]');
  if (img?.dataset?.animatedSrc) {
    img.src = img.dataset.animatedSrc;
  }
}

export function stopGifThumbnail(container) {
  const img = container?.querySelector?.('img.gif-thumbnail[data-static-src]');
  if (img?.dataset?.staticSrc) {
    img.src = img.dataset.staticSrc;
  }
}

export function initColorPicker() {
  $(`.color-picker-container .pickr`).each((index, el) => {
    const $colorInput = $(el).siblings(".color-picker-input").first();
    const elementId = $colorInput.attr("id");
    const pickr = new Pickr({
      el,
      container: "body",
      theme: "nano",
      swatches: [],
      components: {
        preview: true,
        hue: true,
        opacity: true,
        interaction: {
          hex: true,
          rgba: true,
          hsla: true,
          input: true,
        },
      },
      default: $colorInput.val(),
    }).on("changestop", (source, instance) => {
      instance.applyColor();
      let color = pickr.getColor();
      const hexColor = color.toHEXA().toString();
      let inputId = '';
      if (elementId.includes('_fill')) {
        inputId = elementId.replace('_fill_color', '_fill_color_hex');
      }else {
        inputId = elementId.replace('_color', '_color_hex');
        $(`div.dropdown #dropdownMenuButton_${inputId.replace('_color_hex' ,'')} .glyphicon-text-color`).css({
          color: hexColor
        })
        $(`#${inputId}`).trigger('change');
      }
      document.getElementById(inputId).value = hexColor;
      $colorInput.val(hexColor).trigger('change');

    });

    $colorInput.on("change", async function (event) {
      try {
        const currentValue = pickr.getColor().toRGBA.toString();
        const body = { color: currentValue };

        await axios.put("/user/color", body, {
          headers: {
            "Content-Type": "application/json",
          },
        });
      } catch (e) {
        return false;
      }
    });

    const root = pickr.getRoot()
    root.interaction.options.forEach(option => {
      option.defaultValue = option.defaultValue.substring(0, 3)
    })

    eyeDroppers.push($(
      '<a href="#"><i class="c-icon cil-eyedropper"></i></a>',
    ).on('click', function (e) {
      e.preventDefault()
      new EyeDropper()
        .open()
        .then(result => pickr.setColor(result.sRGBHex))

      $(this).blur();
    }));

    $(document).on('keyup', function (e) {
      if (e.keyCode === 13) {
        pickr.hide();
      }
    })
  });

  $('.pcr-interaction').each((index, el) => {
    $(el).append(eyeDroppers[index])
  })
}

export function getFileNameFromURL(url) {
  let full_url = url;
  const url_ary = url.split('?');
  if (url_ary && url_ary.length > 1) {
    full_url = url_ary[0];
  }
  const full_url_ary = full_url.split('/');
  let file_name = '';
  let file_extension = '';
  if (full_url_ary && full_url_ary.length > 0) {
    file_name = full_url_ary[full_url_ary.length - 1];
  }
  if (file_name && file_name.indexOf('.') > -1) {
    const file_name_ary = file_name.split('.');
    file_extension = file_name_ary[file_name_ary.length - 1];
    file_name = file_name.replace('.' + file_extension, '');
  }
  if (!file_name && full_url_ary.length >= 3) {
    file_name = full_url_ary[2];
  }
  const fileName = file_name ? file_name : new Date().getTime();
  return fileName;
}

export function fetchFileData(url) {
  // Check if URL is from Salsify - use backend share endpoint to avoid CORS issues
  const isSalsify = url.includes('images.salsify.com');
  const fetchUrl = isSalsify ? `/share?file=${encodeURIComponent(url)}` : url;

  return new Promise((resolve, reject) => {
    fetch(fetchUrl)
      .then(res => res.blob())
      .then(blob => {
        let full_url = url;
        const url_ary = url.split('?');
        if (url_ary && url_ary.length > 1) {
          full_url = url_ary[0];
        }
        const full_url_ary = full_url.split('/');
        let file_name = '';
        let file_extension = '';
        if (full_url_ary && full_url_ary.length > 0) {
          file_name = full_url_ary[full_url_ary.length - 1];
        }
        if (file_name && file_name.indexOf('.') > -1) {
          const file_name_ary = file_name.split('.');
          file_extension = file_name_ary[file_name_ary.length - 1];
          file_name = file_name.replace('.' + file_extension, '');
        }
        if (!file_extension) {
          file_extension = blob.type.split('/')[1]
        }
        const fileName = (file_name ? file_name : new Date().getTime()) + '.' + file_extension;
        const file = new File([blob], fileName, { type: blob.type, path: url });
        resolve(file);
      })
      .catch(err => {
        toastr.error('There are some errors to get file content. Try again with proper file url.');
        reject(err);
      })
  })
}

export function copyTextToClipboard(text) {
  var textArea = document.createElement( "textarea" );
  textArea.value = text;
  document.body.appendChild( textArea );
  textArea.select();

  let successful = false;
  try {
    successful = document.execCommand('copy');
    console.log('Copying text command was ' + (successful ? 'successful' : 'unsuccessful'));
  } catch (err) {
    console.log('Oops, unable to copy', err);
    successful = false;
  }

  document.body.removeChild(textArea);

  return successful;
}

export async function copyTextToClipboardAsync(text) {
  if (!text || typeof text !== 'string') {
    console.warn('Invalid clipboard text:', text);
    return false;
  }

  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch (error) {
    console.warn('navigator.clipboard failed, falling back...', error);
  }

  //fallback for older browsers or if navigator.clipboard is not available
  const textArea = document.createElement('textarea');
  textArea.value = text;

  textArea.setAttribute('readonly', '');
  textArea.style.position = 'fixed';
  textArea.style.top = '0';
  textArea.style.left = '0';
  textArea.style.width = '1px';
  textArea.style.height = '1px';
  textArea.style.opacity = '0';
  textArea.style.zIndex = '-1';

  document.body.appendChild(textArea);

  textArea.focus();
  textArea.select();
  textArea.setSelectionRange(0, textArea.value.length);

  let successful = false;

  try {
    successful = document.execCommand('copy');
  } catch (error) {
    console.warn('Fallback copy failed:', error);
    successful = false;
  }

  document.body.removeChild(textArea);

  return successful;
}

export function getOrderForAddField(fields) {
  let order = 2000;
  for (let field of fields) {

    if (typeof field.order !== 'number') {
      continue
    }
    if (field.order < order) {
      order = field.order;
    }
  }
  return order - 1;
}
export function getArrayByFileIds(fileIds) {
  let filedIdsArray = [];

  if (fileIds.includes(' ')) {
    filedIdsArray = fileIds.split(' ');
  }
  if (fileIds.includes(',')) {
    filedIdsArray = fileIds.split(',')
  }
  if (!fileIds.includes(' ') && !fileIds.includes(',')) {
    filedIdsArray = [fileIds];
  }
  return filedIdsArray
}
export function getFileIdByProductObjectId(fileIds, objectId) {
  const fileIndex = objectId.split('_').reverse()[0];
  let filedIdsArray = getArrayByFileIds(fileIds);
  return filedIdsArray.at(fileIndex);
}

export function isURL(str) {
  // Check if the string is a URL (absolute or relative)
  const pattern = new RegExp('^(https?:\\/\\/)?(\\/[^\\s]*)?$');
  return !!pattern.test(str);
}

export function setURLParameters(url, params) {
  // Check if the URL is absolute or relative
  const isAbsoluteURL = url.startsWith('http://') || url.startsWith('https://');
  const baseURL = isAbsoluteURL ? url : window.location.origin + url;

  // Create a URL object to work with parameters
  const urlObj = new URL(baseURL);

  // Add or update parameters
  for (const [key, value] of Object.entries(params)) {
    urlObj.searchParams.set(key, value);
  }

  // Return the updated URL
  return isAbsoluteURL ? urlObj.href : urlObj.pathname + urlObj.search;
}

export function deleteURLParameters(url, params) {
  // Check if the URL is absolute or relative
  const isAbsoluteURL = url.startsWith('http://') || url.startsWith('https://');
  const baseURL = isAbsoluteURL ? url : window.location.origin + url;

  // Create a URL object to work with parameters
  const urlObj = new URL(baseURL);

  // Delete specified parameters
  for (const param of params) {
    urlObj.searchParams.delete(param);
  }

  // Return the updated URL
  return isAbsoluteURL ? urlObj.href : urlObj.pathname + urlObj.search;
}

export function cleanImageResourceUrl(url) {
  if (!url || typeof url !== 'string') {
    return url;
  }

  let cleanUrl = removeUrlOriginLocation(url);

  if (!cleanUrl.includes('/share?file=')) {
    return cleanUrl;
  }

  return deleteURLParameters(cleanUrl, [
    'lightweight',
    'scale',
    'scale_width',
    'full_resolution',
    'variant',
    'format',
    'is_thumbnail',
  ]);
}

export function getURLParametersByKey(url, paramKey) {
  // Check if the URL is absolute or relative
  const isAbsoluteURL = url.startsWith('http://') || url.startsWith('https://');
  const baseURL = isAbsoluteURL ? url : window.location.origin + url;

  // Create a URL object to work with parameters
  const urlObj = new URL(baseURL);

  return urlObj.searchParams.get(paramKey);
}

export function getPrimarySecondaryColorFromTheme(color, selectedTheme){
  if ((color === PRIMARY_MODE || color === SECONDARY_MODE) && selectedTheme){
    let theme_color = selectedTheme.getColorByName(color);
    if (theme_color)
      return (theme_color)

  }
  return color;
}

export function isInGroup(groupFields, fieldName) {
  const fieldNames = groupFields.split(',');
  for (const name of fieldNames) {
    if (name.trim() === fieldName) {
      return true;
    }
  }

  return false;
}

export function getPositioningOption(positioning_options, data, fields, field) {
  if (typeof positioning_options !== "undefined") {
    const textFields = fields.filter(
      ({ type }) => [
        FIELD_TYPE_TEXT,
        FIELD_TYPE_TEXT_OPTIONS,
        FIELD_TYPE_TEXT_FROM_SPREADSHEET,
        FIELD_TYPE_MULTI_LINE_TEXT
      ].includes(type)
    );
    const fieldFlags = {};
    Object.keys(data)
      .filter(
        (key) =>
          (key.startsWith(TEXT_PREFIX_ID) ||
            key.startsWith("multi_line_text_")) &&
          !key.endsWith("_offset_x") &&
          !key.endsWith("_offset_y") &&
          !key.endsWith("_angle")
      )
      .map((key) => {
        const field = textFields.find((field) => field.element_id === key);
        if (field) {
          fieldFlags[field.name] = !!data[key];
        }
      });

    const parsedOptions = positioning_options.map((option) => {
      const parsedOption = {};
      option.fields.map(({ field_name, fields, x, y, width }) => {
        parsedOption[field_name] = { fields, x, y, width };
      });
      return parsedOption;
    });

    for (const option of parsedOptions) {
      let res = true;
      for (const key in option) {
        if (
          (option[key].fields == 1 && fieldFlags[key] !== true) ||
          (option[key].fields == null && fieldFlags[key] == true)
        ) {
          res = false;
          break;
        }
      }
      if (res) {
        return option[field.name];
      }
    }
  }
  return null;
}

export function getShadowFabricInstance(instanceId, elementId, shadows = null, bShadow = null, scaleX = 1, scaleY = 1) {
  if (!$('#shadow_effects').is(':checked')) return null

  const customShadow = canvas_data[instanceId]?._data[`${elementId}_custom_shadow`]
  if (customShadow) {
    return new fabric.Shadow(JSON.parse(customShadow))
  }

  if (!(shadows?.shadow && bShadow && shadows.shadow.length)) return null

  const sh = shadows.shadow[bShadow - 1].list;

  // Prevent division by very small values (which would cause extreme offsets)
  const safeScaleX = Math.abs(scaleX) < 0.01 ? 1 : scaleX;
  const safeScaleY = Math.abs(scaleY) < 0.01 ? 1 : scaleY;

  return new fabric.Shadow({
    angle: sh[1].value,
    distance: sh[2].value,
    color: "#000000" + parseInt(String(2.5 * sh[0].value)).toString(16),
    blur: Math.ceil(sh[4].value / safeScaleX),
    offsetX: -sh[2].value * Math.cos((sh[1].value * Math.PI) / 180) / safeScaleX,
    offsetY: sh[2].value * Math.sin((sh[1].value * Math.PI) / 180) / safeScaleY,
  });
}

export function getLockValue (instanceId, elementId) {
  return canvas_data[instanceId]?._data[`${elementId}_locked`] || false
}

export function removeObjectFromCanvas(canvas, search, params = {}) {
  const {
    exactMatch = false
  } = params;

  canvas.getObjects().forEach(function (object) {
    const isObjectMatched =
      object.id &&
      exactMatch
        ? object.id === search
        : object.id.includes(search)

    if (isObjectMatched) {
      canvas.remove(object);
    }
  });
}

export async function createMirror(oImg, elementId, canvas, data) {
  return await new Promise((resolve) => {
    oImg.clone(async (copy) => {
      let mirrorPosition;
      let distance;
      let skew;
      let fade;
      let coords;
      if (oImg.id.startsWith('bk_theme_img')) {
        mirrorPosition = data[`bk_img_mirror_position`][elementId];
        distance = parseInt(data[`bk_img_mirror_distance`][elementId]);
        skew = parseInt(data[`bk_img_mirror_skew`][elementId]);
        fade = data[`bk_img_mirror_fade`][elementId] === "true";
        coords = JSON.parse(data[`bk_img_mirror_coords`][elementId]);
      } else {
        mirrorPosition = data[`${elementId}_mirror_position`];
        distance = parseInt(data[`${elementId}_mirror_distance`]);
        skew = parseInt(data[`${elementId}_mirror_skew`]);
        fade = data[`${elementId}_mirror_fade`] === "true";
      }
      const flipY = mirrorPosition === "top" || mirrorPosition === 'bottom';
      let left =  oImg.left;
      const xTranslate = oImg.width * oImg.scaleX + distance;
      let top = oImg.top;
      const yTranslate = oImg.height * oImg.scaleY + distance;
      switch (mirrorPosition) {
        case 'top':
          top -= yTranslate;
          break;
        case 'right':
          left += xTranslate;
          break;
        case 'bottom':
          top += yTranslate;
          break;
        case 'left':
          left -= xTranslate;
          break;
      }
      const deleteSource = data[`${elementId}_mirror_delete_source`] === 'true';

      copy.set({
        id: oImg.id + '_mirror',
        flipY: flipY,
        flipX: !flipY,
        scaleX: oImg.scaleX,
        scaleY: oImg.scaleY,
        left: left,
        top: top,
        groupName: oImg.groupName,
        element_id: oImg.element_id + '_mirror',
        order: oImg.order,
        fieldId: oImg.fieldId,
      });

      if (oImg.angle && oImg.angle !== 0) {
        const angleRad = Math.abs(oImg.angle) * Math.PI / 180;
        const betweenX = (oImg.width * oImg.scaleX * Math.cos(angleRad)) + (oImg.height * oImg.scaleY * Math.sin(angleRad));
        const betweenY = (oImg.width * oImg.scaleX * Math.sin(angleRad)) + (oImg.height * oImg.scaleX * Math.cos(angleRad));
        copy.set({angle: - oImg.angle});

        switch (mirrorPosition) {
          case 'top':
            copy.set({top: oImg.top - betweenY});
            break;
          case 'right':
            copy.set({left: oImg.left + betweenX});
            break;
          case 'bottom':
            copy.set({top: oImg.top + betweenY});
            break;
          case 'left':
            copy.set({left: oImg.left - betweenX});
            break;
        }
      }

      if (skew !== 0) {
        const xSkewTranslate = (Math.tan(skew * Math.PI / 180) * copy.height * copy.scaleY) / 2;
        const ySkewTranslate = (Math.tan(skew * Math.PI / 180) * copy.width * copy.scaleY) / 2;

        switch (mirrorPosition) {
          case 'top':
            copy.set({
              skewX: skew,
              left: left + xSkewTranslate,
            });
            break;
          case 'right':
            copy.set({
              skewY: skew,
              top: top - ySkewTranslate,
            });
            break;
          case 'bottom':
            copy.set({
              skewX: skew,
              left: left - xSkewTranslate,
            });
            break;
          case 'left':
            copy.set({
              skewY: skew,
              top: top + ySkewTranslate,
            });
            break;
        }
      }
      if (deleteSource) {
        canvas.remove(oImg);
      }

      if (fade) {
        const backgroundColor = 'white';
        var rect = new fabric.Rect();

        rect.set({
          id: 'gradient',
          left: left - copy.width * copy.scaleX / 2,
          top: top - copy.height * copy.scaleY / 2,
          opacity: 1,
          width: copy.width * copy.scaleX,
          height: copy.height * copy.scaleY,
          order: copy.order + 1,
        })

        let gradientSettings = {
          type: 'linear',
          gradientUnits: 'pixels',
          coords: {
            x1: 0,
            y1: 0,
            x2: rect.width,
            y2: 0
          },
          colorStops:[
            { offset: 0, color: backgroundColor, opacity: 0 },
            { offset: 1, color: backgroundColor, opacity: 1},
          ]
        }

        switch (mirrorPosition) {
          case 'top':
            gradientSettings.coords.x2 = 0;
            gradientSettings.coords.y1 = rect.height;
            break;
          case 'bottom':
            gradientSettings.coords.x2 = 0;
            gradientSettings.coords.y2 = rect.height;
            break;
          case 'left':
            gradientSettings.coords.x2 = 0;
            gradientSettings.coords.x1 = rect.width;
            break;
        }

        rect.fill = new fabric.Gradient(gradientSettings);
        copy.set({opacity:0.4});
      }

      if (fade) {
        canvas.add(copy, rect);
      } else {
        canvas.add(copy);
      }

      await new Promise((resolve) => {
        let settings = {
          id: oImg.id,
          groupName: oImg.groupName,
          element_id: oImg.element_id,
          order: oImg.order,
          selectable: oImg.selectable,
          evented: oImg.evented,
          fieldId: oImg.fieldId ? oImg.fieldId : `mirror_group_${elementId}`,
        }

        if (coords?.left !== undefined || coords.top !== undefined) {
          settings = {...settings,left: coords.left,
            top: coords.top}
        }

        const grouped = fade ? [oImg, copy, rect] : [oImg, copy];
        const group = new fabric.Group(grouped, settings);

        canvas.remove(copy);

        if (fade) {
          canvas.remove(rect);
        }

        canvas.add(group);
        resolve();
      })

      resolve();
    });
  })
}


export function setOrder(canvas) {
  let order = 1;
  const objects = canvas.getObjects();
  const objects_ordered = [];

  objects.sort(function (a, b) {
    return b.order - a.order;
  });

  objects.forEach(function (element) {
    if (element.order) {
      objects_ordered[order] = element;
      order ++;
    }

    canvas.bringToFront(element);
  });

  objects_ordered.slice().forEach(function (x) {
    canvas.bringToFront(x);
  });
}

export function updateBoundingBoxInfo(formData, templateId) {
  const EXCLUDE_KEYS = ['type', 'element_ids[]'];
  const grid = $('#template-group-preview');
  const customer_id = grid.attr('data-customer-id');
  const layout_id = grid.attr('data-layout-id');
  const url = '/banner/' + customer_id + '/group/' + layout_id + '/template/' + templateId + '/update_bounding_box';

  return axios({
    method: 'post',
    url: url,
    data: formData,
  }).then((res) => {
    const preview = previews.find(({ id }) => id === templateId);

    if (!preview) {
      return;
    }

    for (const [key, value] of formData.entries()) {
      if (EXCLUDE_KEYS.includes(key)) {
        continue;
      }
      // should rewrite this, its a quick fix,
      if (key === 'product_image_index[]') {
        if (!preview.data['product_image_index']) {
          preview.data['product_image_index'] = [];
        }
        if (preview.data['product_image_index'].indexOf(value) === -1) {
          preview.data['product_image_index'].push(value.toString());
        }
      } else {
        preview.data[key] = value;

      }
    }
    // should rewrite this, its a quick fix, 
    delete preview.data['p_width[]']
    delete preview.data['p_height[]']
  });
}

export async function asyncUpdateBoundingBoxInfo(formData, templateId) {
  const EXCLUDE_KEYS = ['type', 'element_ids[]'];
  const grid = $('#template-group-preview');
  const customer_id = grid.attr('data-customer-id');
  const layout_id = grid.attr('data-layout-id');
  const url = '/banner/' + customer_id + '/group/' + layout_id + '/template/' + templateId + '/update_bounding_box';

  await axios({
    method: 'post',
    url: url,
    data: formData,
  });
  const preview = previews.find(({ id }) => id === templateId);

  if (!preview) {
    return;
  }

  for (const [key, value] of formData.entries()) {
    if (EXCLUDE_KEYS.includes(key)) {
      continue;
    }

    preview.data[key] = value;
  }
}

export async function updateDynamicTemplateHeight(formData, templateId) {
  const EXCLUDE_KEYS = ['type', 'element_ids[]'];
  const grid = $('#template-group-preview');
  const customer_id = grid.attr('data-customer-id');
  const layout_id = grid.attr('data-layout-id');
  const url = '/banner/' + customer_id + '/group/' + layout_id + '/template/' + templateId + '/update_dynamic_template_height';

  axios({
    method: 'post',
    url: url,
    data: formData,
  }).then((res) => {
    const preview = previews.find(({ id }) => id === templateId);

    if (!preview) {
      return;
    }

    for (const [key, value] of formData.entries()) {
      if (EXCLUDE_KEYS.includes(key)) {
        continue;
      }

      preview.data[key] = value;
    }
  });
}

export async function updateAutoFontSizeValue(templateId, tableId, newValue) {
  const grid = $('#template-group-preview');
  const customer_id = grid.attr('data-customer-id');
  const layout_id = grid.attr('data-layout-id');
  const url = '/banner/' + customer_id + '/group/' + layout_id + '/template/' + templateId + '/' + tableId + '/update_auto_font_size_value';

  const formData = new FormData();
  formData.append('new_auto_font_size_value', newValue);

  axios({method: 'post', url: url, data: formData});
}

export function getSettingsDataInstance(settingData) {
  return new SettingsTemplateData(parseJsonData(settingData, {
    fields: []
  }));
}

const getPreview = () => {
  const { previews = [] } = getShowPageScope() ?? {};

  return previews;
};

export function unFocusObjects(activeObject) {
  getPreview().forEach(({ canvas }) => {
    if (activeObject === canvas.getActiveObject()) return;

    if (canvas.getActiveObject()) {
      canvas.discardActiveObject();
      canvas.renderAll();
    }
  });
}

export function getProductImageBaseDimension(canvasData, data = canvasData._data) {
  const dimension = data?.product_image_base_dimension;

  if (
    Number.isFinite(dimension?.width) && dimension.width > 0
    && Number.isFinite(dimension?.height) && dimension.height > 0
  ) {
    return dimension;
  }

  return canvasData.dimension;
}

export async function calculateDataForAllProductImages(files, canvasData, data) {
  const product = canvasData.product;
  const productImageSettings = canvasData.product_image_settings;
  const smartObjCoords = canvasData.smartObjCoords;
  const productAutoPositioning = canvasData?._data?.product_auto_positioning;

  //is mobile hero logic
  const useProductBoxDimensions = canvasData?._data?.is_mobile_hero;

  // Saved product offsets and scales are relative to this base area, even after AI resizing.
  const baseDimension = getProductImageBaseDimension(canvasData, data);
  const canvasWidth = baseDimension.width || 800;
  const canvasHeight = baseDimension.height || 600;
  const configuredProductWidth = Number(product?.width) || 0;
  const configuredProductHeight = Number(product?.height) || 0;
  const defaultProductBoxSize = Math.min(canvasWidth, canvasHeight) * 0.2;
  const minProductSize = Math.min(canvasWidth, canvasHeight) * 0.25;
  const isImplicitFullCanvasArea = configuredProductWidth >= canvasWidth * 0.95
    && configuredProductHeight >= canvasHeight * 0.95;
  const usesFallbackProductArea = isImplicitFullCanvasArea
    || (!configuredProductWidth && !configuredProductHeight);

  // Templates without a product area still need a usable placement box. Using
  // the full canvas height here makes a newly added product image fill the
  // entire layout instead of appearing as a centered product image.
  let product_width = configuredProductWidth && !isImplicitFullCanvasArea
    ? configuredProductWidth
    : canvasWidth;
  let product_height = configuredProductHeight && !isImplicitFullCanvasArea
    ? configuredProductHeight
    : defaultProductBoxSize;

  // Apply the legacy minimum only to explicitly configured product dimensions.
  if (configuredProductWidth && !isImplicitFullCanvasArea && product_width < minProductSize) {
    product_width = canvasWidth;
  }
  if (configuredProductHeight && !isImplicitFullCanvasArea && product_height < minProductSize) {
    product_height = canvasHeight;
  }

  let left = 0;
  const top = usesFallbackProductArea
    ? (canvasHeight - product_height) / 2
    : (+product['top'] || 0);
  const productAlignment = usesFallbackProductArea
    ? 'center'
    : product?.alignment;
  const margin = +data['product_space_product_space'] || 0;

  let auto_position = true;
  if (['0', 'false', false, 0].includes(productAutoPositioning)) {
    auto_position = false;
  }

  if (files.length > productImageSettings.length) {
    files = files.slice(0, productImageSettings.length);
  }

  let sum_width_dimension = 0;
  let gname;

  files.forEach((file, index) => {
    if (productImageSettings[index]['Option1'] !== 'Hero') {
      if (auto_position) {
        sum_width_dimension += (file.related_files?.[0]?.width || 0);
      }
    }
    if (useProductBoxDimensions && +productImageSettings?.[index]?.['Width'] && +productImageSettings?.[index]?.['Height']) {
      product_width = +productImageSettings[index]['Width'] / +productImageSettings[index]['Scale'];
      product_height = +productImageSettings[index]['Height'] / +productImageSettings[index]['Scale'];
    }

    if (productImageSettings[index]['Group Name']) {
      gname = productImageSettings[index]['Group Name'];
    }
  });

  if (smartObjCoords[gname] && smartObjCoords[gname]['Width'] && smartObjCoords[gname]['Height']) {
    product_width = +smartObjCoords[gname]['Width'];
    product_height = +smartObjCoords[gname]['Height'];
  }

  product_width -= margin * (files.length - 1);

  let imagesData = await Promise.all(
    files.map((file) => loadFabricImage(file.related_files[0], sum_width_dimension, product_width)
    )
  );

  const maxHeight = imagesData.reduce(
    (acc, { height }) => acc < height ? height : acc, 0
  );

  let imageRatio = 1;

  if (auto_position) {
    imageRatio = maxHeight > product_height ? product_height / maxHeight : 1;
  }

  imagesData = imagesData.map((item) => {
    if (!auto_position) {
      imageRatio = Math.min(
        product_width / item.width,
        product_height / item.height,
        1
      );
    }
    item.width *= imageRatio;
    item.height *= imageRatio;
    return item;
  });

  let totalWidth = 0;
  if (auto_position) {
    totalWidth = imagesData.reduce((acc, { width }) => acc + width, 0);
  } else {
    totalWidth = 0;
  }

  if (productAlignment === 'center') {
    left += (product_width - totalWidth) / 2;
  } else if (productAlignment === 'right') {
    left += product_width - totalWidth;
  }

  return {
    left,
    top,
    product_height,
    margin,
    imagesData
  };
}

const imageCache = new Map();

function loadFabricImage(file, sum_width_dimension, product_width) {
  return new Promise((resolve) => {
    const { getIsLightweight } = getShowPageScope();
    const is_lightweight = getIsLightweight();
    const url = Object.hasOwn(file, 'is_url') && file.is_url === true
      ? file.path
      : `/share?file=${file.path}&lightweight=${is_lightweight}`;

    // if (imageCache.has(url)) {
    //   const dataURL = imageCache.get(url);
    //   fabric.Image.fromURL(dataURL, (oImg) => {
    //     finalize(oImg);
    //   });
    //   return;
    // }

    const fallbackUrl = "/images/missing-image.png";

    fabric.Image.fromURL(url, (oImg) => {
      if (!oImg || !oImg._element) {
        toastr.warning('This image is unavailable or corrupted');
        console.warn(`Main image failed: ${url}. Loading fallback...`);
        fabric.Image.fromURL(fallbackUrl, (fallbackImg) => {
          if (!fallbackImg || !fallbackImg._element) {
            toastr.error("Fallback image also failed!");
            return;
          }

          finalize(fallbackImg, true);
        });

        return;
      }

      finalize(oImg, false);
    }, {
      crossOrigin: 'anonymous'
    });

    function getBaseName(filename) {
      if (!filename) return '';
      const idx = filename.lastIndexOf('.');
      return idx === -1 ? filename : filename.slice(0, idx);
    }

    function finalize(oImg) {
      const width = sum_width_dimension
        ? (product_width * file.width) / sum_width_dimension
        : product_width;
      const ratio = width / oImg.width;
      const height = oImg.height * ratio;

      oImg.set({
        fileName: Object.hasOwn(file, 'is_url') && file.is_url === true
          ? (file.name === 'product_placeholder_img' ? file.name : file.path)
          : getBaseName(file?.name),
      });

      resolve({ image: oImg, width, height });
    }
  });
}

export function removeRepeatingLinkParams(url, parameter) {
  const { getIsLightweight } = getShowPageScope();
  const is_lightweight = getIsLightweight();
  const matches = url.match(/&full_resolution/g);

  if (matches && matches.length) {
    url = url.replace(new RegExp(parameter, 'g'), '').replace(/=+$/g, '');
  }

  return url.replace(/^.*:\/\/[^\/]+/, '') + is_lightweight;
}

export function removeUrlOriginLocation(url) {
  const hasOriginLocation = url.startsWith('http://') || url.startsWith('https://');

  if (hasOriginLocation) {
    return '/' + url.split('/').slice(3).join('/')
  }

  return url;
}


export const themesTemplatePopulator = (response) => {

  const { data } = response;

  data.instances.forEach(instance => {
    instance.themes = instance.themeIds.map(id => data.themes.find(globalTheme => globalTheme.id === id))
  })

  return { data }
}

export function sortBySufix(array) {

  if (!Array.isArray(array)) {
    return [];
  }

  return array.sort((a, b) => {
    const numA = Number(a.split('_').pop());
    const numB = Number(b.split('_').pop());

    return numA - numB;
  });
}

export function moveToStart(arr, index) {
  if (index < 0 || index >= arr.length) return arr;

  const [item] = arr.splice(index, 1);
  arr.unshift(item);
  return arr;
}

export function safeJsonParse(value, defaultValue = false) {
  if (typeof value === 'string') {
    try {
      return JSON.parse(value);
    } catch {
      return defaultValue
    }
  }
  return defaultValue;
}

export function createImageFromBlob(blob) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = reject;
    img.src = URL.createObjectURL(blob);
  });
}

export function getObjectFromCanvas(canvas, id) {
  return canvas.getObjects().find(obj => obj.id === id);
}

export function getShapeFillStyle({ fillType, fill_color, gradient }) {
  if (!fillType || fillType === 'solid') {
    return fill_color;
  }

  if (fillType === 'gradient' && gradient) {
    try {
      const gradientData = typeof gradient === 'string' ? JSON.parse(gradient) : gradient;
      return createGradient(gradientData);
    } catch (e) {
      console.error('Error parsing gradient:', e);
      return fill_color;
    }
  }

  return fill_color;
}

/**
 * Downloads a file from a URL by fetching it as a blob.
 * This is useful for images to ensure the 'download' attribute works correctly
 * even for cross-origin URLs (given CORS is allowed).
 * 
 * @param {string} url - The URL of the file to download
 * @param {string} fileName - The name to save the file as
 */
export async function downloadFileFromUrl(url, fileName = 'download') {
  try {
    const response = await fetch(url);
    const blob = await response.blob();
    const blobUrl = window.URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = blobUrl;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    window.URL.revokeObjectURL(blobUrl);
    return true;
  } catch (err) {
    console.error('Download failed:', err);
    // Fallback: try opening in new tab
    window.open(url, '_blank');
    return false;
  }
}

async function loadImageViaBlob(url) {
  const resp = await fetch(url);
  if (!resp.ok) throw new Error(`Failed to fetch ${url}: ${resp.status}`);
  const blob = await resp.blob();
  const blobUrl = URL.createObjectURL(blob);
  try {
    return await new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => resolve(img);
      img.onerror = () => reject(new Error(`Failed to decode image ${url}`));
      img.src = blobUrl;
    });
  } finally {
    setTimeout(() => URL.revokeObjectURL(blobUrl), 1000);
  }
}

function drawContainedImage(ctx, img, boxX, boxY, boxW, boxH) {
  const imgRatio = img.naturalWidth / img.naturalHeight;
  const boxRatio = boxW / boxH;
  let drawW;
  let drawH;
  if (imgRatio > boxRatio) {
    drawW = boxW;
    drawH = boxW / imgRatio;
  } else {
    drawH = boxH;
    drawW = boxH * imgRatio;
  }
  const drawX = boxX + (boxW - drawW) / 2;
  const drawY = boxY + (boxH - drawH) / 2;
  ctx.drawImage(img, drawX, drawY, drawW, drawH);
}

function drawCambridgeCallouts(ctx, canvasW, canvasH, callouts) {
  const rectX = canvasW * 0.78;
  const rectW = canvasW * 0.22;
  const topRectY = 0;
  const topRectH = canvasH * 0.73;
  const bottomRectY = canvasH * 0.78;
  const bottomRectH = canvasH * 0.22;

  ctx.fillStyle = '#000';
  ctx.fillRect(rectX, topRectY, rectW, topRectH);
  ctx.fillRect(rectX, bottomRectY, rectW, bottomRectH);

  const flavorText = (callouts.flavorText || 'PRODUCT OR FLAVOR').toUpperCase();
  const countText = (callouts.countText || 'Count').toUpperCase();

  ctx.fillStyle = '#fff';
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';

  // Flavor: rotated -90deg, centered at (89%, 36.5%) of canvas.
  const flavorFontSize = Math.round(canvasH * 0.05);
  ctx.save();
  ctx.translate(canvasW * 0.89, canvasH * 0.365);
  ctx.rotate(-Math.PI / 2);
  ctx.font = `700 ${flavorFontSize}px Arial, sans-serif`;
  ctx.fillText(flavorText, 0, 0);
  ctx.restore();

  // Count: horizontal, centered at (89%, 89%) of canvas.
  const countFontSize = Math.round(canvasH * 0.035);
  ctx.font = `700 ${countFontSize}px Arial, sans-serif`;
  ctx.fillText(countText, canvasW * 0.89, canvasH * 0.89);
}

// The composite the user sees (base + product layer + Cambridge callouts) as a PNG
// blob. Shared by the download and the AI Studio folder copy. (POR-13627 / POR-14659)
export async function composeAttachmentBlob(att) {
  const bgUrl = att?.payload;
  if (!bgUrl) return null;
  const overlayUrl = att.overlayUrl || null;
  const callouts = (att._mrhiCallouts && att._mrhiCallouts.type === 'cambridge')
    ? att._mrhiCallouts
    : null;

  const bgImg = await loadImageViaBlob(bgUrl);
  const w = bgImg.naturalWidth;
  const h = bgImg.naturalHeight;

  const canvas = document.createElement('canvas');
  canvas.width = w;
  canvas.height = h;
  const ctx = canvas.getContext('2d');

  ctx.drawImage(bgImg, 0, 0, w, h);

  if (overlayUrl) {
    try {
      const overlayImg = await loadImageViaBlob(overlayUrl);
      const boxW = w * 0.80;
      const boxH = h * 0.90;
      const boxX = (w - boxW) / 2;
      const boxY = (h - boxH) / 2;
      drawContainedImage(ctx, overlayImg, boxX, boxY, boxW, boxH);
    } catch (e) {
      console.warn('Overlay load failed, composing without overlay', e);
    }
  }

  if (callouts) {
    drawCambridgeCallouts(ctx, w, h, callouts);
  }

  return new Promise((resolve) => canvas.toBlob(resolve, 'image/png'));
}

/**
 * Composes a chat-attachment preview (background + optional product overlay +
 * optional Cambridge MRHI callouts) into a single PNG and triggers a download.
 *
 * Mirrors the visual rendering used in AIChatMessage.vue so the downloaded
 * file matches what the user sees in the chat preview.
 */
export async function downloadAttachmentComposite(att, fileName = 'download.png') {
  const bgUrl = att?.payload;
  if (!bgUrl) return false;
  const hasCallouts = !!(att._mrhiCallouts && att._mrhiCallouts.type === 'cambridge');

  if (!att.overlayUrl && !hasCallouts) {
    return downloadFileFromUrl(bgUrl, fileName);
  }

  try {
    const blob = await composeAttachmentBlob(att);
    if (!blob) throw new Error('Canvas export returned null blob');

    const blobUrl = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = blobUrl;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(blobUrl);
    return true;
  } catch (err) {
    console.error('Composite download failed, falling back to bg-only:', err);
    return downloadFileFromUrl(bgUrl, fileName);
  }
}
